export default {
      id: "video-camera-usage",
      viewBox: "0 0 22 13",
      url: __webpack_public_path__ + "img/icons.svg#video-camera",
      toString: function () {
        return this.url;
      }
    }